<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <CardTextAreaRow
        v-model="stateAward.commonWork.workName"
        label="Название награды/поощрения"
        placeholder="Добавьте название награды/поощрения"
        :disabled="isShowMode"
        :error-messages="errorMessages.workName"
        :required="!isShowMode"
        @input="
          $v.stateAward.commonWork.workName.$touch()
          updateStateAward()
        "
      />

      <CardDateRow
        v-model="stateAward.awardDate"
        label="Дата присуждения"
        placeholder="Добавьте дату присуждения"
        :disabled="isShowMode"
        :error-messages="errorMessages.awardDate"
        :required="!isShowMode"
        @input="
          $v.stateAward.awardDate.$touch()
          updateStateAward()
        "
      />

      <CardFieldRow
        v-model="stateAward.awardFounder"
        label="Учредитель награды"
        placeholder="Добавьте учредителя награды"
        hide-border-bottom
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.awardFounder"
        @input="
          $v.stateAward.awardFounder.$touch()
          updateStateAward()
        "
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { StateAward } from '@/models'
import { required, maxLength } from 'vuelidate/lib/validators'
import { checkDate, setValidateMessages } from '../../../scripts/validation'
import CardFieldRow from '../../ui/row/CardFieldRow'
import CardDateRow from '../../ui/row/CardDateRow'
import CardTextAreaRow from '../../ui/row/CardTextAreaRow'

export default {
  components: {
    CardTextAreaRow,
    CardDateRow,
    CardFieldRow
  },
  props: {
    isShowMode: Boolean,
    selectedItem: Object,
    title: String
  },

  data: () => ({
    stateAward: new StateAward()
  }),

  validations() {
    return {
      stateAward: {
        commonWork: {
          workName: { required, maxLength: maxLength(300) }
        },
        awardDate: { required, checkDate },
        awardFounder: { required, maxLength: maxLength(300) }
      }
    }
  },

  computed: {
    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.stateAward.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.stateAward[key])
      })

      Object.keys(this.$v.stateAward.commonWork.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.stateAward.commonWork[key])
      })

      return allErrors
    }
  },

  methods: {
    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    },

    async updateStateAward() {
      this.$emit('update:selected-item', new StateAward(this.stateAward.getForAPI()))
      this.updateInvalid()
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.stateAward = new StateAward(val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
